import React, {useEffect, useReducer} from 'react';
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import {useParams} from "react-router-dom";
import clsx from "clsx";
import {Card, CardContent, CardHeader, Paper, Typography} from "@mui/material";
import {initTamponiState, TAMPONI_INITIAL_STATE, TamponiReducer} from "../../../../reducers/TamponiReducer";
import {getStoricoPrenotazione} from "../../../../services/TamponiServices";
import {useTheme} from "@mui/styles";
import { Skeleton } from '@mui/material';
import {lightBlue, orange} from "@mui/material/colors";
import moment from "moment";

const StoricoPrenotazione = () => {
	const classes = BaseStyle();
	let {id} = useParams();
	const theme = useTheme();
	const [state, dispatch] = useReducer(TamponiReducer, TAMPONI_INITIAL_STATE, initTamponiState);
	
	useEffect(() => {
		getStoricoPrenotazione(id, dispatch)
	}, [id, dispatch])
	
	return (
        <React.Fragment>
            <Card className={clsx(classes.roundBorder)} style={{height: "100%", display: "flex", flexDirection: "column"}}>
				<CardHeader
					title={<Typography
						variant={"h6"}><b>Storico della prenotazione</b></Typography>}
					subheader={"Dalla più recente alla meno recente"}
				/>
				<CardContent style={{flexGrow: 1}}>
					{
						state.loadingGetStorico ? <Skeleton/> :
							state.errorGetStorico !== "" ? "Err" :
								state.storicoPrenotazioni.length === 0 ? "Non c'è storico" :
									state.storicoPrenotazioni
										.sort((a, b) => new Date(b.dataModifica) - new Date(a.dataModifica))
										.map((item, index) => {
											return (
                                                <Paper elevation={0} key={index} id={"paper-storico" + index}
												       style={{
													       backgroundColor: item.lastModify?.toLowerCase().includes("richiesta utente") ?
														       (theme.palette.mode === "light" ? orange[50] : orange[800]) :
														       (theme.palette.mode === "light" ? lightBlue[50] : lightBlue[800]),
													       borderRadius: 24,
													       padding: 16,
													       marginRight: 100,
													       marginTop: 16
												       }}>
                                                    <Typography variant={"subtitle2"} color={"textSecondary"}>
														<b>{item.lastModify}</b> in data: {moment(item.dataModifica).format("DD/MM/YYYY - HH:mm")}
													</Typography>
                                                    <Typography variant={"subtitle1"}>
														{item.note?.replaceAll(/#(\S*)/g, "")}
													</Typography>
                                                </Paper>
                                            );
										})
					}
				</CardContent>
			</Card>
        </React.Fragment>
    );
};

export default React.memo(StoricoPrenotazione);
